import { create } from 'zustand';

export type ToastType = {
	icon?: 'alert' | 'confirm' | string;
	content: string;
	subContent?: string;
	showTime?: number;
};

type ToastStore = {
	toast: ToastType | null;
	openToast: (payload: ToastType) => void;
	closeToast: () => void;
	closeAll: () => void;
};

export const useToastStore = create<ToastStore>((set) => ({
	toast: null,
	openToast: (payload) => set({ toast: payload }),
	closeToast: () => set({ toast: null }),
	closeAll: () => set({ toast: null }),
}));
